
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcNumberInputField as ObcNumberInputFieldElement} from '@oicl/openbridge-webcomponents/dist/components/number-input-field/number-input-field.js';
 
 
 

 
 export const ObcNumberInputField = createComponent({
   react: React,
   tagName: 'obc-number-input-field',
   elementClass: ObcNumberInputFieldElement,
   events: {
     
     onInput: 'input' as EventName<CustomEvent<unknown>>,
   }
  });
 
 